/**
 * @generated SignedSource<<ebcc15fa984798d36d37c4875464a105>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedUserRecommendations_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"UserRecommendationsGrid_user">;
  readonly " $fragmentType": "HpSharedUserRecommendations_user";
};
export type HpSharedUserRecommendations_user$key = {
  readonly " $data"?: HpSharedUserRecommendations_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedUserRecommendations_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedUserRecommendations_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserRecommendationsGrid_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "f91bee7339f44c992f17c18b1a8c6079";

export default node;
